// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__aTlrQ","side":"Layout_side__i3QCS","main":"Layout_main__1Sb6v","header":"Layout_header__uETuI","content":"Layout_content__zLHYD"};